import { useEffect, useState } from 'react';
import styles from './Popup.module.css';
import axios from 'axios';
import { useForm, Controller } from "react-hook-form";
import { Button, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material';
import dayjs from 'dayjs';
import { Close } from '@mui/icons-material';
import { authData } from '../GetAuth';
import { Check, X } from 'react-feather';

export default function ReassignBookingDriverPopup({ selectedId, setLoading, modalClose, setAllData, setSnackbarType, setSnackbarOpen, setSnackbarMessage }) {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [driverList, setDriverList] = useState([]);

    const { handleSubmit, control, formState: { errors } } = useForm({
        mode: 'onChange'
    });

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + 'v1/p-driver-dd-list', {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            }
        }).then(response => {
            if (response.data.status === 'SUCCESS') {
                setDriverList(response.data.data);
            }
        });
    }, [API_TOKEN]);

    const onSubmitLocal = (data) => {
        modalClose(false);
        setLoading(true);

        data = { ...data, bookingIds: [selectedId] }

        axios.post(process.env.REACT_APP_API_URL + 'v1/reassign-bookings', data, {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            }
        }).then(response => {
            if (response.data.status === 'SUCCESS') {
                setLoading(false);
                setSnackbarType('success');
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);

                setAllData(prev => {
                    return prev.map(i => {
                        if (i?.id === selectedId)
                            return { ...i, driver: { ...i?.driver, name: response.data.driver, assigned_date: dayjs().format('YYYY-MM-DD') } };
                        return i;
                    });
                })
            } else {
                setLoading(false);
            }
        }).catch(error => {
            setLoading(false);
        });
    }

    const unAssign = () => {
        modalClose(false);
        setLoading(true);

        let data = { bookingIds: [selectedId] }

        axios.post(process.env.REACT_APP_API_URL + 'v1/unassign-bookings', data, {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            }
        }).then(response => {
            if (response.data.status === 'SUCCESS') {
                setLoading(false);
                setSnackbarType('success');
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);

                setAllData(prev => {
                    return prev.filter(i => i?.id !== selectedId);
                })
            } else {
                setLoading(false);
            }
        }).catch(error => {
            setLoading(false);
        });
    }

    return (<>
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className={`${styles.PopupTitleBar}`}>
            Assign Booking Details To Driver
            <IconButton aria-label="close" onClick={(e) => modalClose(false)} sx={{ position: "absolute", right: 8, top: 8 }}><Close /></IconButton>
        </DialogTitle>
        <DialogContent className={`${styles.PopupContent}`}>
            <div className={`${styles.FullDiv}`}>
                <p className={`${styles.PopupTitle}`}>Choose a driver to assign this booking to, or unassign it entirely.</p>
                <form onSubmit={handleSubmit(onSubmitLocal)}>
                    <div className={`${styles.FormGroupFull}`}>
                        <div className={`FormHalfGroup`}>
                            <FormControl fullWidth>
                                <InputLabel id="driver-select-label">Select Driver*</InputLabel>
                                <Controller
                                    control={control}
                                    name="driver_id"
                                    rules={{ required: 'Please select driver' }}
                                    render={({ field }) => (<Select
                                        {...field}
                                        labelId="driver-select-label"
                                        label="Select Driver*"
                                    >
                                        {driverList?.map(i => {
                                            return <MenuItem key={i?.id} value={i?.id}>{i?.name}</MenuItem>
                                        })}
                                    </Select>)}
                                />
                            </FormControl>
                            {errors.driver_id && (<span className={`ErrorM`}>{errors?.driver_id?.message}</span>)}
                        </div>
                    </div>
                    <div className={`${styles.ButtonAction}`}>
                        <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => unAssign()}>Unassign</Button>
                        <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">Re-assign</Button>
                    </div>
                </form>
            </div>
        </DialogContent>
    </>)
}